import { accountsAuthRequest } from "src/engine/modules/authRequest"

// Спека https://next.stoplight.io/infotech-group/accounts-admin/version%2F1.0/main.hub.yml?view=/admin-api/role
// Реализовывать другие методы по необходимости

export const getList = ({ query, orderBy, offset, limit } = {}) =>
  accountsAuthRequest({
    url: `/roles`,
    params: {
      query,
      orderBy,
      offset,
      limit,
    },
  })

export const getListCount = ({ query } = {}) =>
  accountsAuthRequest({
    url: `/roles/count`,
    params: {
      query,
    },
  })
